// extracted by mini-css-extract-plugin
module.exports = {"ul":"Paging_ul__3ods5","li":"Paging_li__1ywbt","a":"Paging_a__1c9_I"};